<template>
  <div>
    <slot></slot>
  </div>
</template>
<script>

  export default {
    components: {}
  }
</script>



// WEBPACK FOOTER //
// Plain.vue?2cda79ea